module.exports = __webpack_public_path__ + "static/favicon.2d9a1ada.ico";


//////////////////
// WEBPACK FOOTER
// ./static/favicon.ico
// module id = 191
// module chunks = 107818501498521 114276838955818